import React, { useEffect, useState } from 'react';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, MenuItem, Select, FormControl, InputLabel, Grid } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import { Bar } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from 'chart.js';
import { useNavigate } from 'react-router-dom';

// Register required components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement);

const valueFormatter = (value) => `${value} LKR`;

function Reports() {
    const [dailySalesData, setDailySalesData] = useState([]);
    const [pendingPaymentsData, setPendingPaymentsData] = useState([]);
    const [topLotteryData, setTopLotteryData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedDistributor, setSelectedDistributor] = useState('');
    const [loading, setLoading] = useState(true);

    // Fetch daily sales data
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch daily sales data from the provided API
                const salesResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/salesByDistributor');
                const salesData = await salesResponse.json();
                setLoading(false);

                // Transform the data for the Bar chart
                const transformedSalesData = salesData.map(item => ({
                    drawDate: new Date(item.drawDate).toLocaleDateString(), // Format date to local string
                    totalSales: parseFloat(item.totalSales), // Convert totalSales to number
                    distributorName: item.distributorName // Use distributorName directly
                }));

                setDailySalesData(transformedSalesData);

                // Fetch Pending Payments
                const pendingResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/getPendingPaymentsByDistributor');
                const pendingData = await pendingResponse.json();

                const transformedPendingData = pendingData.map(item => ({
                    distributor: item.distributor,
                    pending: parseFloat(item.pending),
                }));

                setPendingPaymentsData(transformedPendingData);

                // Fetch Top Lottery Data
                const lotteryResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/getTopSellingLotteryByCompany');
                const lotteryData = await lotteryResponse.json();

                setTopLotteryData(lotteryData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    // Filter pending payments based on search term
    const filteredPendingPayments = pendingPaymentsData.filter(payment =>
        payment.distributor.toLowerCase().includes(searchTerm.toLowerCase())
    );

    
    const navigate = useNavigate();

    
  const goBack = () => {
    const confirmAction = window.confirm("Are you sure you want to go back?");
    if (confirmAction) {
      navigate(-1); 
    }
  };

    // Prepare data for charts
    const dailySalesChartData = {
        labels: dailySalesData.filter(item => !selectedDistributor || item.distributorName === selectedDistributor).map(item => item.drawDate),
        datasets: [
            {
                label: 'Sales',
                data: dailySalesData.filter(item => !selectedDistributor || item.distributorName === selectedDistributor).map(item => item.totalSales),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            }
        ],
    };

    const lineChartData = {
        labels: dailySalesData.map(item => item.drawDate), // X-axis labels as dates
        datasets: [
            {
                label: 'Total Sales',
                data: dailySalesData.map(item => item.totalSales), // Sales data for the line chart
                borderColor: 'rgba(54, 162, 235, 1)', // Blueish color
                backgroundColor: 'rgba(54, 162, 235, 0.2)', // Light blue for area fill
                fill: true, // Fill the area under the line
            },
        ],
    };

    // Get unique distributor names for the dropdown
    const distributorNames = [...new Set(dailySalesData.map(item => item.distributorName))];

    return (
        <>
   
        <Grid xs = {12} md = {12}>
          <div style={{display : 'flex',alignItems : 'center',justifyContent : 'left',height : 40}}>
          <button
          style={{
                  backgroundColor : 'transparent',
                  color: 'Black',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: 30,
                  marginTop : 10
              }}
              onClick={goBack}
          >
        <ArrowCircleLeftIcon fontSize='2'/>
      </button>
        
      </div>

      </Grid>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '2rem',
            minHeight: '100vh',
            paddingTop: '0',
        }}>
            <Card sx={{ width: '97%', padding: '20px', marginTop: '20px' }}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 style={{ margin: 0 }}>DASHBOARD</h2>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* Daily Sales by Distributor Bar Chart */}
                        <Card sx={{ width: '48%', padding: '20px' }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ fontSize: '25px', marginTop: '0px' }}>Daily Sales by Distributor</p>
                                <FormControl fullWidth sx={{ marginBottom: '20px' }}>
                                    <InputLabel>Distributor</InputLabel>
                                    <Select
                                        value={selectedDistributor}
                                        onChange={(e) => setSelectedDistributor(e.target.value)}
                                    >
                                        <MenuItem value=""><em>All Distributors</em></MenuItem>
                                        {/* Dynamically load distributors */}
                                        {distributorNames.map((name, index) => (
                                            <MenuItem key={index} value={name}>
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {loading ? <p>Loading...</p> : (
                                    <Bar data={dailySalesChartData} options={{
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                display: true,
                                            },
                                        },
                                    }} />
                                )}
                            </CardContent>
                        </Card>

                        {/* Table for Pending Payments */}
                        <Card sx={{ width: '48%', padding: '20px', marginLeft: '20px' }}>
                            <CardContent>
                                <p style={{ fontSize: '25px', marginTop: '0px' }}>Pending Payments by Distributor</p>
                                <TextField
                                    label="Search Distributor"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    sx={{ marginBottom: '20px', width: '100%' }}
                                />
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: '600' }}>Distributor</TableCell>
                                                <TableCell style={{ fontWeight: '600' }}>Pending (LKR)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredPendingPayments.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{row.distributor}</TableCell>
                                                    <TableCell>{valueFormatter(row.pending)}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                        {/* Line Chart for Daily Sales */}
                        <Card sx={{ width: '50%', padding: '20px' }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ fontSize: '25px', marginTop: '0px' }}>Daily Sales</p>
                                {loading ? <p>Loading...</p> : (
                                    <Line data={lineChartData} options={{
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                display: true,
                                            },
                                        },
                                    }} />
                                )}
                            </CardContent>
                        </Card>

                        {/* Top Lottery Sales by Company with Filter */}
                        <Card sx={{ width: '48%', padding: '20px', marginLeft: '20px' }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ fontSize: '25px', marginTop: '0px' }}>Top Selling Lotteries by Company</p>
                                <FormControl fullWidth sx={{ marginBottom: '20px' }}>
                                    <InputLabel>Company</InputLabel>
                                    <Select
                                        value={selectedCompany}
                                        onChange={(e) => setSelectedCompany(e.target.value)}
                                    >
                                        <MenuItem value=""><em>All Companies</em></MenuItem>
                                        {topLotteryData.map((company, index) => (
                                            <MenuItem key={index} value={company.companyName}>
                                                {company.companyName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TableContainer>
                                    <Table>
                                        <TableHead> 
                                            <TableRow>
                                                <TableCell style={{ fontWeight: '600' }}>Lottery Name</TableCell>
                                                <TableCell style={{ fontWeight: '600' }}>Sold Quantity</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {topLotteryData.map((lottery, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{lottery.Lottery}</TableCell>
                                                    <TableCell>{lottery.counts}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Box>
                </CardContent>
            </Card>
        </div>
        </>
    );
}       

export default Reports;



